<template>
  <div class="w-screen max-w-sm h-full">
    <div class="h-full flex flex-col shadow-xl overflow-y-auto bg-white p-4 lg:p-6">
      <div class="prose prose-sm" v-html="mdToHtml" />
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'ProductRequirements',

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    mdToHtml() {
      return marked(this.product.requirements);
    },
  },
};
</script>
